module.exports = __webpack_public_path__ + "img/a6d05a1.png";